import { Route, Routes as RoutesContainer } from "react-router";
import { Create, Edit, Level } from "../index";

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/level' element={<Level />} />
      <Route exact path='/level/create' element={<Create />} />
      <Route exact path='/level/edit/:id' element={<Edit />} />
    </RoutesContainer>
  );
};
export default Routes;
